/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Navigate_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to navigate to folder" |
*
* @param {Explorer_Nav_Navigate_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_navigate_failed_toast = /** @type {((inputs?: Explorer_Nav_Navigate_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Navigate_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de navigation vers le dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Navigation zum Ordner fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile navigare nella cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось перейти в папку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo navegar a la carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法导航到文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダに移動できませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर तक पहुंचने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível navegar até a pasta.")
	return /** @type {LocalizedString} */ ("Failed to navigate to folder")
});